import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isMessageListOptionDirty(state) {
    var savedOptions = state.userOptions;
    var showSenderOnTopInListView = getFallbackValueIfNull(state.optionState.showSenderOnTopInListView, savedOptions.ShowSenderOnTopInListView);
    return showSenderOnTopInListView !== savedOptions.ShowSenderOnTopInListView;
});
//# sourceMappingURL=isSenderSubjectOptionDirty.js.map